<app-doc-viewer
  title="Search"
  subtitle="Geo"
  [dependencies]="['ConfigService', 'LanguageService']"
>
  <app-example-viewer codeFolder="geo/search" configFolder="environments">
    @if (!isTouchScreen) {
      <span title="Details">
        Pointer activated: {{ igoSearchPointerSummaryEnabled }} (F2
        activate/deactivate the pointer location).
      </span>
    }
    <igo-map-browser
      #mapBrowser
      [map]="map"
      [view]="view"
      [igoContextMenu]="actionbarMenu"
      igoLongPress
      igoSearchPointerSummary
      [igoSearchPointerSummaryDelay]="500"
      [igoSearchPointerSummaryEnabled]="igoSearchPointerSummaryEnabled"
      (menuPosition)="onContextMenuOpen($event)"
    >
      <div class="map-actions --vertical --bottom --right">
        <igo-zoom-button [map]="map" color="primary" />
      </div>
    </igo-map-browser>

    <igo-panel title="Search">
      <igo-search-bar
        [term]="term"
        (pointerSummaryStatus)="onPointerSummaryStatusChange($event)"
        [searchSettings]="true"
        [store]="searchStore"
        [termSplitter]="termSplitter"
        (searchTermChange)="onSearchTermChange($event)"
        (search)="onSearch($event)"
        (clearFeature)="removeFeatureFromMap()"
        (searchSettingsChange)="onSearchSettingsChange()"
        [reverseSearchCoordsFormatEnabled]="igoReverseSearchCoordsFormatEnabled"
        (reverseSearchCoordsFormatStatus)="
          onReverseCoordsFormatStatusChange($event)
        "
      />

      <igo-search-results
        [store]="searchStore"
        [term]="term"
        [termSplitter]="termSplitter"
        placeholder="false"
        [settingsChange$]="settingsChange$"
        (resultFocus)="onResultFocus($any($event))"
        (resultSelect)="onResultSelect($any($event))"
        (moreResults)="onSearch($event)"
      >
        <ng-template #igoSearchItemToolbar let-result="result">
          <igo-search-add-button [map]="map" [layer]="result" />
        </ng-template>
      </igo-search-results>
    </igo-panel>

    @if (selectedFeature) {
      <igo-panel title="Details">
        <igo-feature-details [feature]="selectedFeature" />
      </igo-panel>
    }

    <ng-template #actionbarMenu>
      <igo-actionbar
        [store]="store"
        [withIcon]="false"
        [horizontal]="true"
        [mode]="actionBarMode"
      />
    </ng-template>
  </app-example-viewer>
</app-doc-viewer>
